import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Participant } from '../../../interfaces/participant';

export interface ReportTransplantDialogData {
  participant: Participant;
}

export interface ReportTransplantDialogResult {
  confirmed: boolean;
  transplantDate: Date;
}

@Component({
  selector: 'app-report-transplant-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormsModule
  ],
  templateUrl: './report-transplant-dialog.component.html',
  styleUrl: './report-transplant-dialog.component.scss'
})
export class ReportTransplantDialogComponent {
  transplantDate: Date;

  constructor(
    public dialogRef: MatDialogRef<ReportTransplantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReportTransplantDialogData
  ) {
    // Default to today's date
    this.transplantDate = new Date();
  }

  get participant(): Participant {
    return this.data.participant;
  }

  get participantName(): string {
    return `${this.participant.firstName || ''} ${this.participant.lastName || ''}`.trim();
  }

  isFormValid(): boolean {
    return !!this.transplantDate;
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    if (!this.isFormValid()) return;

    this.dialogRef.close({
      confirmed: true,
      transplantDate: this.transplantDate
    });
  }
}
